<template>
  <div ref="summary">
    <!-- New Design -->
    <div class="appointment-summary">
      <div class="p-bottom-10">
        <span class="select-services-dropdown-title">Appointments</span>
        <div class="btn-group pull-right m-0-mobile parent-show-dropdown">
          <a href="javascript:" @click.stop="showDropdown" data-toggle="dropdown" data-too="tooltip"
             data-placement="bottom"
             aria-haspopup="true" aria-expanded="false">
            <svg width="20" style="fill: #2E4051;" height="20" viewBox="0 0 20 20" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10
                                        18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                    fill="#03A9F4"/>
            </svg>
          </a>
          <ul class="dropdown-menu">
            <li><a @click="addMoreTimeForService(service,visits);">Add new appointment</a></li>
            <li class="divider"></li>
            <li><a @click="addRecurringAppointment(service)">Add recurring appointment</a></li>
          </ul>
        </div>
      </div>

      <div class="row m-0-8 marker-cursor summary-container" v-for="(visit, index) of visits" @click="openAppointmentInfo(index,service.service_id,service.clone)">
        <div :class="{'col-lg-12  d-flex':service.viewPage, 'p-left-0 p-right-0 col-md-12 col-xs-12 d-flex justify-content-between': true}" >
          <div class="col-md-10 p-left-0">

            <div :class="{'p-right-0 col-lg-9 col-md-7 col-xs-12 float-right-web appointment-date':true, 'p-left-0':!service.viewPage, 'p-left-0':service.viewPage}">

                      <span>
                          {{ visit.startTime }} - {{ visit.endTime }}
                      </span>
                      <span >
<!--                                 <svg width="16" height="16" viewBox="0 0 16 16" fill="none"-->
<!--                                      xmlns="http://www.w3.org/2000/svg">-->
<!--                                 <path-->
<!--                                     d="M11.18 4.81219C10.3025 3.93469 9.155 3.49219 8 3.49219V7.99219L4.82 11.1722C6.575 12.9272 9.425 12.9272 11.1875 11.1722C12.9425 9.41719 12.9425 6.56719 11.18 4.81219ZM8 0.492188C3.86 0.492188 0.5 3.85219 0.5 7.99219C0.5 12.1322 3.86 15.4922 8 15.4922C12.14 15.4922 15.5 12.1322 15.5 7.99219C15.5 3.85219 12.14 0.492188 8 0.492188ZM8 13.9922C4.685 13.9922 2 11.3072 2 7.99219C2 4.67719 4.685 1.99219 8 1.99219C11.315 1.99219 14 4.67719 14 7.99219C14 11.3072 11.315 13.9922 8 13.9922Z"-->
<!--                                     fill="#2E4051"/>-->
<!--                                 </svg>-->
                                 ({{ trimString(!visit.is_all_day_event ?visit.calculate_booking_duration:visit.part_of_day )}})
                            </span>


            </div>
            <div class="col-lg-3 col-md-5 col-xs-12 p-left-3 float-left-web">
              <div class="date-box">
                {{ startFullDateFormatted(visit.startDate) }}
              </div>
            </div>
          </div>
          <div class="col-md-2 p-right-0">

                            <div class="btn-group float-position pair_btn_new_uniq parent-show-dropdown">
                                <a :ref="`appointment_dropdown${index}`" href="javascript:" @click.stop="showDropdown" data-toggle="dropdown"
                                   data-too="tooltip" data-placement="bottom"
                                   aria-haspopup="true" aria-expanded="false"
                                   class="btn btn-default dropdown-toggle  create-btn FontSize">
                                <i class="fa fa-ellipsis-v " style="color:rgba(138, 138, 138,1);font-size: 18px;"></i>
                                 </a>
                                <ul class="dropdown-menu pair_of_all_li w_und_767" id="pair_of_all_li"
                                    style="right: 0; left: auto;">

                                <li>
                                    <a @click.stop="addMoreTimeForService(service,visits,index);" class="details_info_opt">
                                          <span></span>
                                          <span>Duplicate Appointment</span>
                                    </a>
                                </li>

                                <li v-if=" index >0 ">
                                    <a @click="deleteAppointment(index,service.service_id,service.clone)"
                                       class="details_info_opt">
                                        <span></span>
                                        <span>Delete Appointment</span>
                                    </a>
                                </li>
                             </ul>
                        </div>
          </div>
        </div>
        <div class="col-md-12 col-xs-12 contractor-field p-left-0 p-right-0">

          <div class="col-md-6 col-xs-6 p-left-0 " style="text-align: left;" >
            <span class="gray-text span-font-size dropdown" >
                   <a class="dropdown-toggle" data-toggle="dropdown" @click.stop="" style="text-decoration: none; color: #2E4051" @mouseover="toggleDropdown" @mouseleave="toggleDropdown"  aria-haspopup="true">
                    <div style="display: inline-block" v-html="visit.contractor_img"></div>
                    <span>
                        {{ visit.contractor_text }}
                      </span>
                    <span class="caret"></span>
                    </a>
                    <div class="dropdown-menu">
                        <contractor-info @click.stop :id="visit.contractor_id" item-type="booking" :item-id="visit.booking_id"></contractor-info>
                    </div>
              </span>




          </div>
          <div class="col-md-5 col-xs-5 p-left-0 p-right-0" style="text-align: right;"  v-if="  get_item_type != 'estimate' ">
                        <span v-if="visit.fieldworkerVisitStatus && visit.contractorInfo  && get_item_type != 'estimate'  "
                              :class="`status-div ${ visit.fieldworkerVisitStatus.divClass } mb-5`"
                              @click.stop="accept_or_rejectAdminServices(visit.fieldworkerVisitStatus.title_confirmation,visit.booking_id ,visit.visit_status)">
                                        <span class="labels-font font-family-Roboto color-text">
                                            {{     visit.fieldworkerVisitStatus.title_confirmation     }}
                                        </span>
                                    </span>
            <confirm-attendance-button
                v-if="service.viewPage && visit.fieldworkerVisitStatus && visit.fieldworkerVisitStatus.visit_confirmed=='Confirmed'"
                :title="`${(visit.fieldworkerVisitStatus||{}).visit_confirmed}`"
                class-div="labels-font confirm-color"
                optional-custom-style="padding: 8px 8px 8px 8px!important; margin-bottom: 10px;"
                :element-id="`custom_object_${visit.booking_id}`"
                :booking-id='`${visit.booking_id}`'
                :optional-visit-id='`${visit.multiple_day_id}`'
                :info-for-confirmation='getInfoForConfirmation( `${visit.contractor_id}` ,`${visit.contractorInfo.username}`)'
                @child-event-toggleCollapse="toggleCollapse(index)"  >
            </confirm-attendance-button>
            <confirm-attendance-button
                v-if="  service.viewPage && visit.fieldworkerVisitStatus && visit.fieldworkerVisitStatus.visit_confirmed !='Confirmed'"
                                       :title="`${(visit.fieldworkerVisitStatus||{}).visit_confirmed}`"
                                       class-div="labels-font unconfirm-color"
                                       optional-custom-style="padding: 6px 12px 6px 12px!important; margin-bottom: 10px;"
                                       :element-id="`custom_object_${visit.booking_id}`"
                                       :booking-id='`${visit.booking_id}`'
                                       :optional-visit-id='`${visit.multiple_day_id}`'
                                       :info-for-confirmation='getInfoForConfirmation( `${visit.contractor_id}` ,`${visit.contractorInfo.username}`)'
                                       @child-event-toggleCollapse="toggleCollapse(index)"  >
            </confirm-attendance-button>
          </div>
          <div class="col-md-1 col-xs-2 p-right-5">
            <i v-if="hasDate && visit.visit_status=='accepted'" :ref="`toggleIcon${index}`"
               class="fa fa-chevron-down rotate rotate-180 float-right cursor-pointer"
               style="color: #2E4051;font-size: 18px;"
               @click.stop="toggleCollapse(index)"></i>
          </div>
        </div>

        <booking-view-contractor-tracking-map v-if="hasDate && visit.visit_status=='accepted'"
                                              v-model="visit.fieldworkerVisitStatus"
                                              :visit="visit" fromPage="summary"
                                              :is-running-late="visit.is_running_late == 1"
                                              :class="{'collapsed': visit.isCollapsed}"
                                              :is-virtual="isVirtual">
        </booking-view-contractor-tracking-map>

      </div>

    </div>


    <!-- New Design -->
  </div>
</template>

<script>

import {EventBus} from "@/events/event-bus";
import moment from "moment";
import {addRecurringAppointment, addMoreTimeForService, uuidv4, deleteAppointment} from "@/events/sharedMethods.js";
import BookingViewContractorTrackingMap from "@/modules/Booking/components/maps/BookingViewContractorTrackingMap.vue";

export default {
  name: "AppointmentsSummary",
  components: {BookingViewContractorTrackingMap},
  props: ['service', 'hasDate'],
  data() {
    return {
      businessType: this.service.businessType ?? null,
      dropdownVisible: {}
    }
  },
  computed: {
    visits() {
      return this.service.visits
    },
    get_item_type() {
      return this.service.itemType
    },
    isVirtual() {
      return this.businessType == 'virtual'
    }
  },
  methods: {
      openAppointmentInfo(index, serviceId , clone){
          setTimeout(function (){
              var el = $("#booking_visits_" + serviceId + "_" + clone + ">span")[index];
              el.scrollIntoView();
          },100);
      },
    toggleCollapse(index) {
      this.visits[index].isCollapsed = !this.visits[index].isCollapsed
      $(this.$refs['toggleIcon' + index]).toggleClass('rotate-180')
      this.$forceUpdate()
    },
    getInfoForConfirmation(contractor_id, contractorInfo_name) {
      return {
        item_type: "Technician",
        id: parseInt(contractor_id),  // Assuming `visit` is part of your data
        name: contractorInfo_name,
        item_id: this.visits[0].booking_id
      };
    },
    getTimezoneIdentifier(timezone) {
      if (timezone) {
        try {
          const dateTime = new Date().toLocaleString("en-US", {timeZone: timezone});
          const offset = new Date(dateTime).getTimezoneOffset();
          const sign = offset > 0 ? '-' : '+';
          const hours = Math.abs(Math.floor(offset / 60)).toString().padStart(2, '0');
          const minutes = Math.abs(offset % 60).toString().padStart(2, '0');
          const timezoneIdentifier = `(${sign}${hours}:${minutes} GMT)  ${timezone}`;
          return timezoneIdentifier;
        } catch (e) {
          return "Invalid Timezone";
        }
      }
      return "No Timezone Provided";
    },
    showDropdown(event) {
        // check if the current page is vue page or not using indicator this.service.viewPage
      if (typeof this.service !== 'undefined' && this.service  && this.service.viewPage ) {
        $(event.target).parents('.parent-show-dropdown').find('ul')
        if (this.visits.length > 1){
         $(event.target).parents('.parent-show-dropdown').find('ul').dropdown('toggle')
       }
       }else {
        $(event.target).parents('.parent-show-dropdown').find('ul').dropdown('toggle')

}
    },
    toggleDropdown(event) {
      $(event.target).dropdown('toggle')
    },
    closeDropdowns() {
      // Close all dropdowns
      for (let key in this.dropdownVisible) {
        this.dropdownVisible[key] = false;
      }
    },
    startDateFormatted(startDate) {
      return moment(startDate).format("DD MMM")
    },startFullDateFormatted(startDate) {
      return moment(startDate).format("DD MMM YYYY")
    },
    accept_or_rejectAdminServices(popUpLabel, book, type) {
      // $(`#acceptance_${visitId}`).trigger("click")
      $("#popupi").modal("show")
      EventBus.$emit('triggerAcceptOrRejectService', popUpLabel, book, type);
    },
    trimString(str1){
      if(str1)
        return str1.trim()
     else
        return ''
    },
    addRecurringAppointment,
    addMoreTimeForService,
    uuidv4,
    deleteAppointment,

  },
  mounted() {
    $('.dropdown-toggle').dropdown()
    EventBus.$on('onBusinessTypeChanged', business_type => {
      this.businessType = business_type
    });
    EventBus.$on('onTodayProcessLoaded', (todayProcessName, todayProcessClass, visit_id) => {
      // let visit = this.visits.filter(visit => visit.multiple_day_id==visit_id)[0]
      // visit.fieldworkerVisitStatus.title_confirmation = todayProcessName
      // visit.fieldworkerVisitStatus.divClass = todayProcessClass
      this.$forceUpdate();
    });
    let businessType = $('#business_address').val();
    if (businessType !== 'mobile' && businessType !== 'virtual') {
      businessType = 'fixed';
    }
    this.businessType = businessType

  }

}
</script>

<style scoped>
.fs-13 {
  font-size: 13px;
}
.d-flex
{
  display: flex;
}
.summary-container {
  border: 1px solid #E0E2E5;
  border-radius: 12px;
  Padding: 16px;
  background-color: #FFFFFF;
}

.appointment-summary {
  Padding: 16px 0;
  font-weight: 400;
  font-size: 16px;
  color: #2E4051;
}

.m-0-8 {
  margin: 0 0 8px 0;
}

.date-box {
  border: 1px solid #E0E2E5;
  border-radius: 8px;
  padding: 2px 16px;
  background-color: #008CFA26;
  font-size: 17px;
  display: inline-block;
  text-align: center;
}

.col-p-top-10 {
  padding-top: 10px;
}

.font-size-17 {
  font-size: 17px;
}

.font-size-14 {
  font-size: 14px;
}

.status-label {
  color: #FFFFFF !important;
  border-radius: 100px !important;
  padding: 2px 8px 4px 8px !important;
  background-color: blue;
}

.labels-font {
  font-size: 12px;
  color: #2E4051;
  display: inline-block;
  margin-bottom: 10px;
}

.confirm-color {
  background-color: #37BD5D !important;
  color: #FFFFFF !important;
  border-radius: 100px !important;
  padding: 2px 8px 6px 8px !important;
  width: auto !important;
}

.color-text {
  color: #FFFFFF;
}

.unconfirm-color {
  background-color: #FF932F !important;
  color: #FFFFFF !important;
  border-radius: 100px !important;
  padding: 2px 8px 6px 8px !important;
  width: auto !important;

}

.status-div {
  color: #FFFFFF !important;
  border-radius: 100px !important;
  padding: 2px 12px 6px 12px !important;
  width: auto !important;
}

.float-position {
  float: right;
}

.p-left-0-15 {
  padding-left: 0px;
}

.collapsed {
  display: none;
}

.rotate {
  -moz-transition: all 0.5s linear;
  -webkit-transition: all 0.5s linear;
  transition: all 0.5s linear;
  padding-right: 5px;
}

.rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0.5);
  -webkit-transform: rotate(-180deg);
  -moz-transform: rotate(-180deg);
  -ms-transform: rotate(-180deg);
  -o-transform: rotate(-180deg);
  transform: rotate(-180deg);
  display: inline-block;
}
.contractor-field{
  padding-bottom: 15px;
  padding-top: 15px;
}
.popover{
  width: 315px;
}
.px-0{
  padding-left: 0;
  padding-right: 0;
}
.appointment-date{
  padding-top: 5px;
}

@media (max-width: 768px) {
  .mobile-p-left-52 {
    padding-left: 52px !important;
  }

  .col-p-top-10 {
    padding-top: 0px !important;
  }

  .mobile-p-right-0 {
    padding-right: 0px !important;
  }
  .contractor-field{
    text-align: center;
    padding-bottom: 0px;
  }

}
.justify-content-between
{
  justify-content: space-between;
}
@media (min-width: 1025px) and (max-width: 1440px) {
  .p-left-0-15 {
    padding-left: 15px;
  }
}
@media (min-width: 1199px){
  .col-xl-1
  {
    width: 10%;
  }
}
@media (min-width:992px){
.float-right-web
{
float: right;
}
  .float-left-web
  {
    float: left;
  }
}
</style>